export default __webpack_public_path__ + "static/media/bg3.4577310c.jpg";